import { render, staticRenderFns } from "./disabilitycardManagerPage.vue?vue&type=template&id=e02115c0&"
import script from "./disabilitycardManagerPage.vue?vue&type=script&lang=js&"
export * from "./disabilitycardManagerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports